class HeroTestimonialsRotator {
  constructor() {
    this.rotatingCards = document.querySelectorAll('.hero-testimonials__card--rotating');
    this.carousel = document.querySelector('.hero-testimonials__carousel');
    this.track = document.querySelector('.hero-testimonials__track');
    this.autoScrollInterval = null;
    this.scrollDirection = 1;
    this.isPaused = false;
    this.scrollSpeed = 1;
    this.pauseDelay = 3000;
    this.currentCardIndex = 0;
    this.allCards = [];
    
    if (this.rotatingCards.length > 0) {
      this.init();
    }
    
    if (this.carousel && window.innerWidth < 990) {
      this.initAutoScroll();
    }
  }

  init() {
    this.rotatingCards.forEach((card) => {
      const slides = card.querySelectorAll('.hero-testimonials__rotating-slide');
      
      if (slides.length <= 1) return;

      const speedAttr = card.closest('[data-rotation-speed]');
      const speed = speedAttr ? parseInt(speedAttr.dataset.rotationSpeed, 10) : 4000;

      this.startRotation(slides, speed);
    });
  }

  startRotation(slides, speed) {
    let currentIndex = 0;
    const totalSlides = slides.length;

    setInterval(() => {
      slides[currentIndex].classList.remove('is-active');
      
      currentIndex = (currentIndex + 1) % totalSlides;
      
      slides[currentIndex].classList.add('is-active');
    }, speed);
  }

  initAutoScroll() {
    this.allCards = Array.from(this.track.querySelectorAll('.hero-testimonials__card'));
    
    const rotatingCard = this.carousel.querySelector('.hero-testimonials__card--rotating');
    if (rotatingCard) {
      this.currentCardIndex = this.allCards.indexOf(rotatingCard);
    }
    
    if (this.allCards[this.currentCardIndex]) {
      setTimeout(() => {
        this.scrollToCard(this.currentCardIndex, () => {
          setTimeout(() => {
            this.scrollToNextCard();
          }, this.pauseDelay);
        });
      }, 100);
    }

    this.carousel.addEventListener('mouseenter', () => this.pauseScroll());
    this.carousel.addEventListener('mouseleave', () => this.resumeScroll());
    this.carousel.addEventListener('touchstart', () => this.pauseScroll());
    this.carousel.addEventListener('touchend', () => this.resumeScroll());
  }

  scrollToNextCard() {
    if (this.isPaused) {
      setTimeout(() => this.scrollToNextCard(), 100);
      return;
    }

    this.currentCardIndex += this.scrollDirection;

    if (this.currentCardIndex >= this.allCards.length) {
      this.currentCardIndex = this.allCards.length - 1;
      this.scrollDirection = -1;
    } else if (this.currentCardIndex < 0) {
      this.currentCardIndex = 0;
      this.scrollDirection = 1;
    }

    this.scrollToCard(this.currentCardIndex, () => {
      setTimeout(() => {
        this.scrollToNextCard();
      }, this.pauseDelay);
    });
  }

  scrollToCard(index, callback) {
    const card = this.allCards[index];
    if (!card) return;

    const cardRect = card.getBoundingClientRect();
    const carouselRect = this.carousel.getBoundingClientRect();
    const targetScroll = this.carousel.scrollLeft + (cardRect.left - carouselRect.left) - (carouselRect.width - cardRect.width) / 2;

    const startScroll = this.carousel.scrollLeft;
    const distance = targetScroll - startScroll;
    const duration = 800;
    const startTime = performance.now();
    
    const easeInOutCubic = (t) => {
      return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
    };
    
    const animateScroll = (currentTime) => {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1);
      const easedProgress = easeInOutCubic(progress);
      
      this.carousel.scrollLeft = startScroll + (distance * easedProgress);
      
      if (progress < 1) {
        requestAnimationFrame(animateScroll);
      } else {
        if (callback) callback();
      }
    };
    
    requestAnimationFrame(animateScroll);
  }

  pauseScroll() {
    this.isPaused = true;
  }

  resumeScroll() {
    setTimeout(() => {
      this.isPaused = false;
    }, 500);
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => new HeroTestimonialsRotator());
} else {
  new HeroTestimonialsRotator();
}

document.addEventListener('shopify:section:load', (event) => {
  if (event.target.querySelector('.hero-testimonials')) {
    new HeroTestimonialsRotator();
  }
});
